import dayjs from "dayjs";

const hasTimezone = (dateStr: string) => /([Zz]|[+-]\d{2}:?\d{2})$/.test(dateStr);

export const formatDate = (dateStr: string): string => {
  const normalized = hasTimezone(dateStr) ? dateStr : `${dateStr}T12:00:00`;
  return dayjs(normalized).format("MMM DD, YYYY");
};
